import { ClipboardText } from "@phosphor-icons/react";
import { ClipboardCopy } from "lucide-react";
import { toast } from "sonner";

export const CopyToClipboardButton = ({ text }: { text: string }) => {
    return (
        <button
            onClick={() => {
                navigator.clipboard.writeText(text);
                toast.info("Copied to clipboard", {
                    icon: <ClipboardCopy size={18} />,
                    description: <pre>{text}</pre>,
                });
            }}
            className="text-gray-500 hover:text-gray-700"
        >
            <ClipboardText size={16} />
        </button>
    );
};
